import { mapCollection } from '../../utils/collection.utils';
import { PollGroup } from '../poll-group';
import { CompanyWithResearchUnitBuilder } from './company-with-research-unit.builder';
import { PollBuilder } from './poll.builder';
import { ResearchUnitBuilder } from './research-unit.builder';
import { TargetBuilder } from './target.builder';

export class PollGroupBuilder {
  static fromJson(json) {
    return (json)
      ? new PollGroup(
        json.hash,
        json.name,
        CompanyWithResearchUnitBuilder.fromJson(json.company),
        TargetBuilder.fromJson(json.target),
        PollBuilder.fromList(json.polls),
        ResearchUnitBuilder.fromJson(json.researchUnit),
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(PollGroupBuilder.fromJson, list) : [];
  }
}
